import PayslipAndBenefits from "../common/PayslipAndBenefits";

const EmployeeCompensation = () => <PayslipAndBenefits />;

export default EmployeeCompensation;
